import { createContext } from "react";

export const inputValues = createContext({})